/**
 * OPS-WS-4: 課金状態分布カード（フィルタ適用前の全件）。
 * sales_counter 単体前提へ縮退（#1479、カウンターシリーズ4製品構想は2026-07-02撤退。
 * 単一 Supabase 接続のため取得状況は単一値で表示する）。
 */
import type { BillingStatus, WorkspaceListResult } from '../../lib/workspaces-api';
import { BILLING_STATUS_LABEL } from './labels';

export interface WorkspaceHealthSummaryProps {
  distribution: WorkspaceListResult['billingDistribution'];
  sourceStatus: WorkspaceListResult['sourceStatus'];
  total: number;
}

const STATUSES: ReadonlyArray<BillingStatus> = ['active', 'trialing', 'past_due', 'canceled'];

const STATUS_COLOR: Record<BillingStatus, string> = {
  active: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  trialing: 'bg-sky-100 text-sky-800 border-sky-200',
  past_due: 'bg-rose-100 text-rose-800 border-rose-200',
  canceled: 'bg-slate-100 text-slate-600 border-slate-200',
};

const SOURCE_STATUS_LABEL: Record<'ok' | 'skipped' | 'error', string> = {
  ok: '取得済',
  skipped: '未接続（skip）',
  error: '取得失敗',
};

export function WorkspaceHealthSummary({
  distribution,
  sourceStatus,
  total,
}: WorkspaceHealthSummaryProps) {
  const sourceColor =
    sourceStatus === 'ok'
      ? 'text-emerald-700'
      : sourceStatus === 'error'
        ? 'text-rose-700'
        : 'text-slate-500';

  return (
    <section data-testid="workspace-health-summary" className="mt-4 grid gap-4 md:grid-cols-2">
      <div className="rounded-md border border-slate-200 bg-white p-4 shadow-sm">
        <p className="text-xs uppercase tracking-wide text-slate-500">課金状態分布</p>
        <div className="mt-3 flex flex-wrap gap-2">
          {STATUSES.map((s) => (
            <span
              key={s}
              className={`rounded-full border px-3 py-1 text-xs font-medium ${STATUS_COLOR[s]}`}
            >
              {BILLING_STATUS_LABEL[s]}: {distribution[s]}
            </span>
          ))}
        </div>
        <p className="mt-3 text-xs text-slate-500">
          フィルタ適用前の全件（合計 {Object.values(distribution).reduce((a, b) => a + b, 0)} ws、
          現フィルタ {total} 件）
        </p>
      </div>

      <div className="rounded-md border border-slate-200 bg-white p-4 shadow-sm">
        <p className="text-xs uppercase tracking-wide text-slate-500">Supabase 取得状況</p>
        <p className={`mt-3 text-sm ${sourceColor}`}>{SOURCE_STATUS_LABEL[sourceStatus]}</p>
      </div>
    </section>
  );
}
